import React, { useMemo } from 'react';
import { Button } from '@veneer/core';
import { useDependencyManagerContext } from '../../../contexts/dependencyManager';
import { OperationStatus } from '../../../types';

type TelemetryDownloadButtonProps = {
  'data-testid': string;
  onDownloadClick: () => void;
  telemetryRequestStatus: OperationStatus;
  deviceFamily: string;
  serialNumber: string;
};

const TelemetryDownloadButton: React.FC<TelemetryDownloadButtonProps> = ({
  'data-testid': dataTestId,
  onDownloadClick,
  deviceFamily,
  serialNumber
}) => {
  const { translate } = useDependencyManagerContext();

  const buttonTextKey =
    'components.device-item.telemetry-download-button.download-data';
  const ariaLabelKey =
    'components.device-item.telemetry-download-button.aria-label';

  const unknownDeviceName = translate('components.device-item.no-data.unknown');

  const downloadButtonAnalyticsAttributes = useMemo(
    () => ({
      'data-gtm-category': 'linkClick',
      'data-gtm-id': `device-card-download-button-${serialNumber}`,
      'data-gtm-value': `download-data-${deviceFamily}-${serialNumber}`
    }),
    [serialNumber, deviceFamily]
  );

  return (
    <Button
      colorScheme="default"
      data-testid={dataTestId}
      onClick={onDownloadClick}
      aria-label={translate(ariaLabelKey, {
        deviceFamily: deviceFamily || unknownDeviceName,
        serialNumber
      })}
      {...downloadButtonAnalyticsAttributes}
    >
      {translate(buttonTextKey)}
    </Button>
  );
};

export default TelemetryDownloadButton;
